// eslint-disable-next-line import/no-anonymous-default-export
export default {

    colors: {
        primary: '#101727',
        secundary: '#007b3e',
        background: '#f9f9f9',
        backgroundAlt: '#c7e1ed',
        alternative: '#f84e01'
    },
    textColors: {
        primary: '#000000',
        secundary: '#ffffff',
        alternative: '#007b3e',
    },
    fontSize: {
        small: 'clamp(1rem, 1vw, 1rem) ',
        medium: 'clamp(1rem, 2vw, 1.5rem)',
        large: 'clamp(1.8rem, 1vw, 2.5rem)'
    },
    focusInput: {
        color1: '#46d6f2',
        color: '#4cd43d'

    },
    test: {
        color: '#ffffff',
        Alt: '#e6e6e6',
        color0: '#d5d9e1',
        color1: '#6d7e6b',
        color2: '#101727',
        color3: '#f84e01'
    }
}